import WikiFolderCard from './wiki-folder-card'

export default WikiFolderCard
